module.exports = __webpack_public_path__ + "files/b91b03551cbc5aec3c2970794722f055.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-800.woff2
 ** module id = 971
 ** module chunks = 0
 **/